import FormConditionsPage from './FormConditions.page';

const FormCondition = ({ isMinimized }) => {
  return (
    <div className={`page-wrapper`}>
      <FormConditionsPage />
    </div>
  );
};

export default FormCondition;
